import { Component, inject, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { TelefonoService } from '../../../services/telefono.service';
import { ToastComponent } from '../../../components/toast/toast.component';
import { ToastService } from '../../../services/toast.service';
import { Telefono } from '../../../models/telefono.model';

@Component({
  selector: 'app-modal-agregar-telefono',
  imports: [ReactiveFormsModule, ToastComponent],
  templateUrl: './modal-agregar-telefono.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './modal-agregar-telefono.component.css',
})
export class ModalAgregarTelefonoComponent {
  private readonly formBuilder = inject(FormBuilder);
  private readonly telefonoService = inject(TelefonoService);
  private readonly toastService = inject(ToastService);

  cerrar = output<void>();
  sucursalId = input.required<number>();
  agregarTelefono = output<Telefono>();

  formTelefono = this.formBuilder.group({
    numero: ['', [Validators.required, Validators.maxLength(20)]],
    meta_phone_number_id: ['', [Validators.maxLength(40)]],
    titulo: ['', [Validators.required, Validators.maxLength(50)]],
    descripcion: ['', [Validators.maxLength(120)]],
    proveedor: ['OFICIAL' as 'OFICIAL' | 'NO_OFICIAL', [Validators.required]],
  });

  guardarTelefono() {
    if (this.formTelefono.valid) {
      const { numero, meta_phone_number_id, titulo, descripcion, proveedor } =
        this.formTelefono.value;
      if (!numero || !titulo || numero.trim() === '' || titulo.trim() === '')
        return;
      this.telefonoService
        .crear(this.sucursalId(), {
          numero: numero.trim(),
          meta_phone_number_id: meta_phone_number_id?.trim() || undefined,
          titulo: titulo.trim(),
          descripcion: descripcion?.trim() || '',
          proveedor: (proveedor as 'OFICIAL' | 'NO_OFICIAL') || 'OFICIAL',
        })
        .subscribe({
          next: (telefono) => {
            this.agregarTelefono.emit(telefono as Telefono);
            this.toastService.show({
              text: 'Teléfono agregado exitosamente',
              classname: 'bg-green-500 text-white',
              delay: 3000,
            });
            this.cerrar.emit();
          },
          error: (err) => {
            console.error('Error al crear el teléfono:', err);
            this.toastService.show({
              text: err.message || 'Error al agregar el teléfono',
              classname: 'bg-red-500 text-white',
              delay: 5000,
            });
          },
        });
    } else {
      this.formTelefono.markAllAsTouched();
    }
  }
  cerrarModal() {
    this.cerrar.emit();
  }
}
